import { useApolloClient, useMutation } from "@apollo/client";
import {
  DeleteFileMutation,
  DeleteFileMutationVariables,
  MessageThreadFilesDrawerQuery,
  MessageThreadFilesDrawerQueryVariables,
} from "gql/graphql";
import MESSAGE_THREAD_FILES_DRAWER_QUERY from "modules/messaging/drawers/files-drawer/_networking/message-thread-files-drawer";
import DELETE_FILE_MUTATION from "modules/providers/file-provider/networking/delete-file";

const useDeleteFileMutation = (fileId: string, messageThreadId: string) => {
  const { cache } = useApolloClient();
  return useMutation<DeleteFileMutation, DeleteFileMutationVariables>(
    DELETE_FILE_MUTATION,
    {
      variables: {
        id: fileId,
      },
      onCompleted: () => {
        cache.updateQuery<
          MessageThreadFilesDrawerQuery,
          MessageThreadFilesDrawerQueryVariables
        >(
          {
            query: MESSAGE_THREAD_FILES_DRAWER_QUERY,
            variables: {
              id: messageThreadId,
            },
          },
          (data) => {
            if (!data?.messageThread) {
              return data;
            }

            const fileList = data.messageThread.fileList.filter(
              (file) => file.id !== fileId,
            );

            return {
              ...data,
              messageThread: {
                ...data.messageThread,
                fileList,
                fileCount: fileList.length,
              },
            };
          },
        );
        cache.evict({
          id: cache.identify({
            __typename: "File",
            id: fileId,
          }),
        });
      },
    },
  );
};

export default useDeleteFileMutation;
